// 获取当前时间
export const getNow = () => {
  const date = new Date();
  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  // const hour = date.getHours().toString().padStart(2, '0');
  // const minute = date.getMinutes().toString().padStart(2, '0');
  // const second = date.getSeconds().toString().padStart(2, '0');
  // var now = year + "-" + mon + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
  const now = year + "-" + month + "-" + day;
  return now;
};
// 获取当前时间
export const getYearMonth = () => {
  const date = new Date();
  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  // const hour = date.getHours().toString().padStart(2, '0');
  // const minute = date.getMinutes().toString().padStart(2, '0');
  // const second = date.getSeconds().toString().padStart(2, '0');
  // var now = year + "-" + mon + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
  const now = year + "-" + month;
  return now;
};
// 获取当前时间
export const getMonthDay = () => {
  const date = new Date();
  // const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString();
  const day = date.getDate().toString().padStart(2, "0");
  // const hour = date.getHours().toString().padStart(2, '0');
  // const minute = date.getMinutes().toString().padStart(2, '0');
  // const second = date.getSeconds().toString().padStart(2, '0');
  // var now = year + "-" + mon + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
  const now = `${month}月${day}日`;
  return now;
};
// 格式化数字
export const fomatFloat = (value, n) => {
  let f = Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
  let s = f.toString();
  let rs = s.indexOf(".");
  if (rs < 0) {
    s += ".";
  }
  for (let i = s.length - s.indexOf("."); i <= n; i++) {
    s += "0";
  }
  return s;
};
// 获取前六个月时间
export const prevMonths = (value = 6) => {
  let arr = [];
  let tempStr;
  var date1 = new Date();
  for (let i = value; i > 0; i--) {
    date1.setMonth(date1.getMonth() - i);
    var year = date1.getFullYear().toString().padStart(4, "0");
    var month = (date1.getMonth() + 1).toString().padStart(2, "0");
    tempStr = year + "-" + month;
    arr.push(tempStr);
  }
  return arr;
};
// 格式化日期
export const formatterDate = (timeStr, type) => {
  const date = new Date(timeStr);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以要加1
  const d = String(date.getDate()).padStart(2, "0");
  const h = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const s = String(date.getSeconds()).padStart(2, "0");
  let data;
  if (type == "month") {
    data = `${y}-${m}`;
  } else if (type == "year") {
    data = `${y}`;
  } else {
    data = `${y}-${m}-${d}`;
  }
  return data;
};
//时间加一天
export const addDate = (timeStr) => {
  let date = new Date(timeStr);
  date = date.setDate(date.getDate() + 1);
  date = new Date(date);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以要加1

  const d = String(date.getDate()).padStart(2, "0");

  return `${y}-${m}-${d}`;
};
//月份减一天
export const minusMonth = (timeStr) => {
  let date = new Date(timeStr);
  const y = date.getFullYear();
  const m = String(date.getMonth()).padStart(2, "0"); // 月份从0开始，所以要加1
  const d = String(date.getDate()).padStart(2, "0");

  return `${y}-${m}-${d}`;
};
//月份减一天
export const addMonth = (timeStr) => {
  // 将当前日期增加一个月
  timeStr.setMonth(timeStr.getMonth() + 1);

  // 获取增加一个月后的年、月、日
  const year = timeStr.getFullYear();
  const month = timeStr.getMonth() + 1; // 注意：月份从0开始，所以要加1
  // const day = timeStr.getDate();

  return `${year}-${month}`;
};
